import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Page from 'modules/app/components/Page';
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import clsx from 'clsx';
import useCategory from 'sdk/hooks/discovery/useCategory';
import useGetDiscoverySchema from 'sdk/hooks/discovery/useGetDiscoverySchema';
import styles from './CategoriesPage.module.scss';
import RenderBySchema from './RenderBySchema';

function Category() {
  const { id } = useParams()
  const navigate = useNavigate()

  const { data } = useCategory(id)
  const { data: schema } = useGetDiscoverySchema(`category_${id}`)

  return (
    <div className={clsx(styles.container, styles.containerWithCategory)}>
      <div
        className={styles.containerWithCategoryBack}
        style={{ backgroundImage: data?.cover ? `url(${data?.cover})` : undefined }}
      />
      <h1 className={styles.h1} onClick={() => navigate(-1)}>
        <IconArrowRight />
      </h1>

      <div className={clsx(styles.root, styles.mainCategory)}>
        <h1 className={styles.title}>{data?.name}</h1>
        <RenderBySchema schema={schema} categoryId={id} />
      </div>
    </div>
  )
}

function CategoriesPage() {
  return (
    <Page activeLink="/category">
      <Category />
    </Page>
  )
}

export default CategoriesPage
